<!--操作日志-->
<template>
    <div>
       <Log :sousuo="true" :columns="columns" :xiangqing="true" @showData="getRow" @getData="init" @deleteOpe="deleteSubmit"></Log>
    </div>
</template>

<script>
    import Log from '@/components/log/Log'
    import { logPage, logRemove, logGet} from '@/api/log'

    export default {
        name: 'SYS-LOG-OPERATE',
        components: {
            Log
        },
        data() {
            return {
                columns: [
                    {
                        type:'selection',
                        width: '55px',
                        fixed: 'left'
                    }, {
                        label: '序号',
                        prop: 'operId',
                        fixed: 'left',
                        width: '80px'
                    }, {
                        label: 'ip地址',
                        prop: 'operIp',
                        width: '120px'
                    }, {
                        label: '定位',
                        prop: 'operLocation',
                        width: '120px'
                    }, {
                        label: '用户名',
                        prop: 'operName',
                        width: '120px'
                    }, {
                        label: '手机号',
                        prop: 'mobile',
                        width: '120px'
                    }, {
                        label: '时间',
                        prop: 'operTime',
                        width: '150px'
                    }, {
                        label: '接口',
                        prop: 'operUrl',
                        width: '200px'
                    },/* {
                        label: '方法',
                        prop: 'method',
                        width: '200px'
                    },*/ {
                        label: '类型',
                        prop: 'operatorType'
                        //width: '50px'
                    }, {
                        label: '请求方式',
                        prop: 'requestMethod',
                        width: '150px'
                    }, {
                        label: '状态',
                        prop: 'status',
                        width: '80px'
                    }, {
                        label: '标题',
                        prop: 'title'
                        //width: '50px'
                    }, {
                        label: '请求时长ms',
                        prop: 'totalTime',
                        width: '100px'
                    }, {
                        label: '操作',
                        type: 'template',
                        template: 'action',
                        width: '200px',
                        fixed: 'right'
                    }
                ]
            }
        },
        methods: {
            init(param,data,e) {
                logPage(param, data).then(response => {
                    if (response.code != 200)
                        return e.$message.error(response.msg)
                    // console.log('操作日志',response)
                    e.tablelist = response.data.records
                    e.total = response.data.total
                    e.loading = false
                })
            },
            deleteSubmit(item,e){
                console.log('deleteSubmit',item,e)
                let ids=''
                if(item===''){
                    ids=e.checkedList.map((item)=>{return item.operId}).join(',')
                }else{
                    ids=item.operId
                }
                logRemove(ids).then(response => {
                    console.log('删除操作日志结果',response)
                    if(response.code!=200){
                        return e.$message.error(response.msg)
                    }
                    e.init()
                    e.$message.success(response.msg)
                })
            },
            getRow(item,e){
                logGet(item.operId).then(response=>{
                    if(response.code!=200){
                        return e.$message.error(response.msg)
                    }
                    e.form=response.data
                    e.dialogVisible = true
                })
            }
        }
    }
</script>

<style scoped>

</style>
